import { render, staticRenderFns } from "./zxDetil.vue?vue&type=template&id=682bb887&scoped=true"
import script from "./zxDetil.vue?vue&type=script&lang=js"
export * from "./zxDetil.vue?vue&type=script&lang=js"
import style0 from "./zxDetil.vue?vue&type=style&index=0&id=682bb887&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682bb887",
  null
  
)

export default component.exports